<template>
  <div>
    <top-bar></top-bar>
    <top-nav></top-nav>
    <el-container style="min-height: 500px;padding-bottom: 30px;">
      <router-view></router-view>
    </el-container>
    <help></help>
    <bottom-footer></bottom-footer>
    <floating-menu></floating-menu>
  </div>
</template>

<script>
import TopBar from './topBar'
import bottomFooter from './bottomFooter'
import FloatingMenu from './floatingMenu'
import Help from './help'
import TopNav from './topNav'
export default {
  components: { TopNav, TopBar, FloatingMenu, bottomFooter, Help },
  data () {
    return {
      dialogVisible: false,
      userName: ''
    }
  },
  created () {
  },
  mounted () {
  },
  watch: {
    $route (to, from) {
      // 登录 拦截
    }
  },
  methods: {
  }
}
</script>

<style lang="scss" scoped>
  .img-auth{
    text-align: center;
    height: 100px;
    background-color: #fff;
    padding: 20px;
    img{
      height: 100%;
      margin-left: 80px;
    }
  }
</style>
